import React, { forwardRef, useRef, useState } from "react";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import sass from "./select.module.sass";
import cn from "classnames";
import InputTemp from "components-new/InputTemp";

/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
interface IOption {
	id: number | null;

	[key: string]: any;
}

interface IDropSelect {
	options: IOption[];
	field: string | string[];
	value: string;
	placeholder: string;
	onSelect: (str: IOption) => void;
	query?: string;
	setQuery?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	className?: string;
	current?: IOption;
}

export const FutureSelect = forwardRef<any, IDropSelect>(
	({ options, value, placeholder, field, onSelect, setQuery, query, className = "", current }, forwardRef) => {
		const [show, setShow] = useState(false);
		const [close, setClose] = useState(false);

		const ref = useRef<HTMLDivElement | null>(null);

		const closeDrop = () => {
			setClose(true);
			setTimeout(() => {
				setShow(false);
				setClose(false);
			}, 200);
		};
		useOutsideAlerter(ref.current, closeDrop);

		return (
			<div className={cn(sass.dropWrapper, className)} ref={ref}>
				<div
					ref={forwardRef}
					className={cn(sass.select, sass.select__open)}
					onClick={() => {
						if (show) {
							closeDrop();
						} else {
							setShow((prevState) => !prevState);
						}
					}}>
					{value ? value : placeholder}
					<div className={sass.arrow} />
				</div>
				{show && (
					<div className={cn(sass.drop, { [sass.closeDrop]: close })}>
						{query !== undefined && (
							<div className={sass.search}>
								<InputTemp value={query} onChange={setQuery} searchIcon={true} placeholder={"Поиск"} />
							</div>
						)}
						<div className={sass.searchList}>
							{options.map((_) => {
								let option: string;
								if (typeof field === "string") {
									option = _[field];
								} else {
									option = field.reduce((acc: string, item) => acc + ` ${_[item] || ""}`, "");
								}
								option = option.trim();
								return (
									<p
										key={_.id}
										onClick={() => {
											if (current) {
												if (current.id !== _.id) {
													onSelect(_);
													closeDrop();
												}
											} else {
												onSelect(_);
												closeDrop();
											}
										}}
										className={cn(sass.itemdrop, current && current.id === _.id ? sass.active : "")}>
										{option}
									</p>
								);
							})}
						</div>
					</div>
				)}
			</div>
		);
	},
);
